export default __webpack_public_path__ + "static/media/468.2f60e917.gif";